import FunctionHeader from "presentation/components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import TimesheetDocuments from "presentation/components/Timesheet/TimesheetDocuments";
import usePermissionCheck from "presentation/hooks/use-check-permissions";

interface TimesheetDocumentsPageProps {
  children?: React.ReactNode;
  isDisable?: boolean;
}

const TimesheetDocumentsPage: React.FC<TimesheetDocumentsPageProps> = ({
  children,
  isDisable,
}) => {
  const { isLoading } = usePermissionCheck({ requiredFunction: "timesheets" });

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <div>
      <FunctionHeader title="Mapa de Horas" />
      <TimesheetDocuments />
    </div>
  );
};

export default TimesheetDocumentsPage;
